import './tripDateTable.css';
import '../../dashboard/dashboardTable/dashboardTable.css';
import { useEffect, useState } from 'react';
import { standardDate } from '../../../utils/formatDate';
import { orgBookingCancelFun } from '../../../api/orgTripAPI';
import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import ConfirmationModal from '../../../components/tripStrap/tripStrapFun/cancelBooking';
import { ReactComponent as SortIcon } from '../../../assets/icons/sort-icon-a-z.svg';
import { truncateText } from '../../../utils/maskFields';
import { getTransationCharges } from '../../../utils/getAmountWithTransaction';

//pagination not required as we are populating data from bookingId array.
//And data wont reach more than 200
export default function TripDateTable({ bookingData, contentData, tripStatus, setLoading, refresh, tripDateDetails }) {
    const tableHeader = [
        'Sl No',
        'Name',
        'Start City',
        'Pick Up',
        'Booked On',
        'Seats',
        'Rooms',
        `Reserved /
        Installment`,
        'Transport',
        'Booked Via',
        'People',
        `${tripStatus === 'Completed' ? 'status' : ''}`,
        `${tripStatus === 'Upcoming' ? 'Action' : ''}`
    ];
    const tableHeaderVehicle = [
        'Sl No',
        'Name',
        'Vehicle',
        'Start City',
        'Pick Up',
        'Booked On',
        'Seats',
        'Rooms',
        `Reserved/
        Installment`,
        'Transport',
        'Booked Via',
        'People',
        `${tripStatus === 'Completed' ? 'status' : ''}`,
        `${tripStatus === 'Upcoming' ? 'Action' : ''}`
    ];

    const [showModal, setShowModal] = useState(false);
    const [rowId, setRowId] = useState('');
    const [sortedData, setSortedData] = useState(bookingData);
    const [pickupAsc, setPickupAsc] = useState(true);

    // const sortedBookings = [...bookingData].sort((a, b) => {
    //     const pickupA = a.pickupLocation?.toLowerCase() || '';
    //     const pickupB = b.pickupLocation?.toLowerCase() || '';
    //     return pickupA.localeCompare(pickupB);
    // });

    const getUserData = (row) => {
        return row.userDetails.map(function (user, userKey) {
            return (
                <div key={userKey}>
                    <span>{user?.name ?? 'N/A'}, </span>
                    <span>{user?.age ?? 'N/A'}, </span>
                    <span>{user?.sex ?? 'N/A'}, </span>
                    <span>{user?.phoneNumber ?? 'N/A'}</span>
                </div>
            );
        });
    };

    const getVehicleData = (row) => {
        return (
            <div key={row._id} className='vehicleDataDiv'>
                <div>
                    <span>Mode :</span> {row.vehicle?.mode ?? 'N/A'},{' '}
                </div>
                <div>
                    <span>Model :</span> {row.vehicle?.model ?? 'N/A'},{' '}
                </div>
                <div>
                    <span>Empty Seats :</span> {row.vehicle?.emptySeats ?? 'N/A'},
                </div>
                <div>
                    <span>Comfortable :</span> {row.vehicle?.comfortable ?? 'N/A'}
                </div>
            </div>
        );
    };

    async function handleBookingCancel(e) {
        e.stopPropagation();
        setLoading(true);

        try {
            const newDate = await orgBookingCancelFun({ bookingId: rowId });
            if (newDate.status === 200) {
                toast.success('Successfully cancelled Booking');
                setShowModal(false);
                refresh();
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    }

    useEffect(() => {
        setSortedData(bookingData);
    }, [bookingData]);

    const handleSortByPickUp = () => {
        const sorted = [...sortedData].sort((a, b) => {
            const pickupA = a.pickupLocation?.toLowerCase() || '';
            const pickupB = b.pickupLocation?.toLowerCase() || '';
            return pickupAsc ? pickupA.localeCompare(pickupB) : pickupB.localeCompare(pickupA);
        });
        setSortedData(sorted);
        setPickupAsc(!pickupAsc);
    };

    const handleSortByStartCity = () => {
        const sorted = [...sortedData].sort((a, b) => {
            const startCityA = a.startCity?.toLowerCase() || '';
            const startCityB = b.startCity?.toLowerCase() || '';
            return pickupAsc ? startCityA.localeCompare(startCityB) : startCityB.localeCompare(startCityA);
        });
        setSortedData(sorted);
        setPickupAsc(!pickupAsc);
    };

    const handleSortByBookedVia = () => {
        const sorted = [...sortedData].sort((a, b) => {
            const bookedViaA = a.bookedVia?.toLowerCase() || '';
            const bookedViaB = b.bookedVia?.toLowerCase() || '';
            return pickupAsc ? bookedViaA.localeCompare(bookedViaB) : bookedViaB.localeCompare(bookedViaA);
        });
        setSortedData(sorted);
        setPickupAsc(!pickupAsc);
    };

    return (
        <div className='tripDateContainer'>
            <div className='tableContainer'>
                <table className='table'>
                    <thead className='tableHead'>
                        <tr>
                            {contentData?.group === 'vehicle'
                                ? tableHeaderVehicle.map((head, headKey) => {
                                      return (
                                          <th key={headKey}>
                                              <div className=''>
                                                  {head}
                                                  {head === 'Pick Up' && (
                                                      <SortIcon
                                                          width={17}
                                                          height={16}
                                                          className='cursor-pointer sort-icon'
                                                          onClick={handleSortByPickUp}
                                                      />
                                                  )}
                                                  {head === 'Start City' && (
                                                      <SortIcon
                                                          width={17}
                                                          height={16}
                                                          className='cursor-pointer sort-icon'
                                                          onClick={handleSortByStartCity}
                                                      />
                                                  )}
                                                  {head === 'Booked Via' && (
                                                      <SortIcon
                                                          width={17}
                                                          height={16}
                                                          className='cursor-pointer sort-icon'
                                                          onClick={handleSortByBookedVia}
                                                      />
                                                  )}
                                              </div>
                                          </th>
                                      );
                                  })
                                : tableHeader.map((head, headKey) => {
                                      return (
                                          <th key={headKey}>
                                              <div className='table-header-flex'>
                                                  {head}
                                                  {head === 'Pick Up' && (
                                                      <SortIcon
                                                          width={17}
                                                          height={16}
                                                          className='cursor-pointer sort-icon'
                                                          onClick={handleSortByPickUp}
                                                      />
                                                  )}
                                                  {head === 'Start City' && (
                                                      <SortIcon
                                                          width={17}
                                                          height={16}
                                                          className='cursor-pointer sort-icon'
                                                          onClick={handleSortByStartCity}
                                                      />
                                                  )}
                                                  {head === 'Booked Via' && (
                                                      <SortIcon
                                                          width={17}
                                                          height={16}
                                                          className='cursor-pointer sort-icon'
                                                          onClick={handleSortByBookedVia}
                                                      />
                                                  )}
                                              </div>
                                          </th>
                                      );
                                  })}
                        </tr>
                    </thead>
                    <tbody>
                        {console.log(tripStatus, tripDateDetails, 'tripStatus')}
                        {sortedData.map((row, rowKey) => {
                            return (
                                <tr className={`tableBodyRow `} key={rowKey}>
                                    <td>{rowKey + 1}.</td>
                                    <td className='tripDateNameRow'>{row?.userDetails[0]?.name ?? 'N/A'}</td>
                                    {contentData?.group === 'vehicle' && <td>{getVehicleData(row)}</td>}
                                    <td>{row?.startCity ?? 'N/A'}</td>
                                    <td>{truncateText(row?.pickupLocation, 40) ?? 'N/A'}</td>
                                    <td>{standardDate(row?.createdAt?.split('T')[0])}</td>
                                    <td>{row?.totalSeats ?? '0'}</td>
                                    <td>{row?.totalRooms ?? '0'}</td>
                                    <td
                                        style={{
                                            color:
                                                row?.amountPaid?.isReserved || row?.amountPaid?.isInstallment
                                                    ? 'red'
                                                    : '',
                                            textAlign: 'center',
                                            whiteSpace: 'pre-line',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        {row?.amountPaid?.isReserved || row?.amountPaid?.isInstallment
                                            ? `${row?.amountPaid?.isReserved ? 'Reserved' : 'Installment'}\n${
                                                  row?.amountPaid?.isReserved
                                                      ? `(₹${row?.amountPaid?.reserve}/seat)`
                                                      : row?.amountPaid?.isInstallment
                                                        ? `(₹${row?.amountPaid?.installments?.[0]?.amount})`
                                                        : ''
                                              }
                                              Total: ${row?.amountPaid?.total}
                                              Paid: ${row?.amountPaid?.paid - (row?.amountPaid?.paid > row?.amountPaid?.reserve * row?.totalSeats ? getTransationCharges(row?.amountPaid?.reserve * row?.totalSeats) : 0)}
                                              Balance: ${row?.amountPaid?.total - row?.amountPaid?.reserve * row?.totalSeats}`
                                            : <>Full payment<br />Paid: ₹{Number(row?.amountPaid?.paid) || 0}</>}
                                    </td>
                                    <td>{row?.transport ?? 'N/A'}</td>
                                    <td>{row?.bookedVia ?? 'N/A'}</td>
                                    <td>{getUserData(row)}</td>
                                    <td>
                                        {tripStatus === 'Completed' && (
                                            <span
                                                style={
                                                    row?.tripStatus === 'Cancelled'
                                                        ? { color: 'red', fontWeight: '600' }
                                                        : {}
                                                }
                                            >
                                                {row?.tripStatus}
                                            </span>
                                        )}
                                    </td>
                                    {tripStatus === 'Upcoming' ? (
                                        row?.tripStatus === 'Cancelled' ? (
                                            <td style={{ color: 'red', fontWeight: '600' }}>{row?.tripStatus}</td>
                                        ) : (
                                            <td>
                                                <span
                                                    className='cancelTrip-btn'
                                                    onClick={() => {
                                                        setShowModal(true);
                                                        setRowId(row._id);
                                                    }}
                                                >
                                                    Cancel
                                                </span>
                                            </td>
                                        )
                                    ) : (
                                        <></>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div className='responsiveCardContainer'>
                    {sortedData?.map((row, rowIndex) => (
                        <div key={rowIndex} className={`responsiveCard ${row?.tripStatus?.toLowerCase()}`}>
                            <div className='cardContent'>
                                <p>
                                    <strong>{tableHeader[1]}:</strong>
                                    {row.userDetails[0].name}
                                </p>
                                {contentData?.group === 'vehicle' && (
                                    <p>
                                        <strong>{tableHeaderVehicle[2]}:</strong>
                                        {getVehicleData(row)}
                                    </p>
                                )}
                                <p>
                                    <strong>
                                        {contentData?.group === 'vehicle' ? tableHeaderVehicle[3] : tableHeader[2]}:
                                    </strong>{' '}
                                    {row?.startCity ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>
                                        {contentData?.group === 'vehicle' ? tableHeaderVehicle[4] : tableHeader[3]} :
                                    </strong>{' '}
                                    {row?.pickupLocation ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>
                                        {contentData?.group === 'vehicle' ? tableHeaderVehicle[5] : tableHeader[4]}:
                                    </strong>{' '}
                                    {standardDate(row?.createdAt?.split('T')[0]) ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>
                                        {contentData?.group === 'vehicle' ? tableHeaderVehicle[6] : tableHeader[5]}:
                                    </strong>{' '}
                                    {row?.totalSeats ?? '0'}
                                </p>
                                <p>
                                    <strong>
                                        {contentData?.group === 'vehicle' ? tableHeaderVehicle[7] : tableHeader[6]}:
                                    </strong>{' '}
                                    {row?.totalRooms ?? '0'}
                                </p>
                                <p
                                    style={{
                                        color:
                                            row?.amountPaid?.isReserved || row?.amountPaid?.isInstallment ? 'red' : '',
                                        textAlign: 'center',
                                        verticalAlign: 'middle'
                                    }}
                                >
                                    <strong style={{ color: 'black' }}>
                                        {contentData?.group === 'vehicle' ? tableHeaderVehicle[8] : tableHeader[7]}:
                                    </strong>{' '}
                                    {row?.amountPaid?.isReserved || row?.amountPaid?.isInstallment
                                        ? `${row?.amountPaid?.isReserved ? 'Reserved' : 'Installment'}\n${
                                              row?.amountPaid?.isReserved
                                                  ? `(₹${row?.amountPaid?.reserve}/seat)`
                                                  : row?.amountPaid?.isInstallment
                                                    ? `(₹${row?.amountPaid?.installments?.[0]?.amount})`
                                                    : ''
                                          }
                                              Total: ${row?.amountPaid?.total}
                                              Paid: ${row?.amountPaid?.paid - (row?.amountPaid?.paid > row?.amountPaid?.reserve * row?.totalSeats ? getTransationCharges(row?.amountPaid?.reserve * row?.totalSeats) : 0)}
                                              Balance: ${row?.amountPaid?.total - row?.amountPaid?.reserve * row?.totalSeats}`
                                        : <>Full payment<br />Paid: ₹{Number(row?.amountPaid?.paid) || 0}</>}
                                </p>
                                <p>
                                    <strong>
                                        {contentData?.group === 'vehicle' ? tableHeaderVehicle[9] : tableHeader[8]}:
                                    </strong>{' '}
                                    {row?.transport ?? 'N/A'}
                                </p>
                                <p className={`cardLabelDisplay ${row.userDetails.length > 1 ? 'multiple' : ''}`}>
                                    <strong>
                                        {contentData?.group === 'vehicle' ? tableHeaderVehicle[10] : tableHeader[9]}:
                                    </strong>{' '}
                                    {row?.bookedVia ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>
                                        {contentData?.group === 'vehicle' ? tableHeaderVehicle[11] : tableHeader[10]}:
                                    </strong>{' '}
                                    {getUserData(row)}
                                </p>
                                <p>
                                    <strong></strong>{' '}
                                    {tripStatus === 'Upcoming' ? (
                                        row?.tripStatus === 'Cancelled' ? (
                                            <td style={{ color: 'red', fontWeight: '600' }}>{row?.tripStatus}</td>
                                        ) : (
                                            <td>
                                                <span
                                                    className='cancelTrip-btn'
                                                    onClick={() => {
                                                        setShowModal(true);
                                                        setRowId(row._id);
                                                    }}
                                                >
                                                    Cancel
                                                </span>
                                                <span>Edit</span>
                                            </td>
                                        )
                                    ) : (
                                        <></>
                                    )}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {showModal && (
                <ConfirmationModal
                    setShowModal={setShowModal}
                    handleConfirm={(e) => {
                        handleBookingCancel(e);
                    }}
                    message={'Do you want to cancel the booking?'}
                />
            )}
        </div>
    );
}
